import { gql } from 'graphql-request';

import {
  CurrencyRateBaseCurrency,
  CurrencyRateData,
  CurrencyRateID
} from '../currencyRatesTypes';
import { DateType, UUID } from '../../../types';

export interface FetchCurrencyRatesQueryResponse {
  id: CurrencyRateID;
  baseCurrency: CurrencyRateBaseCurrency;
  data: CurrencyRateData;
  uuid: UUID;
  createdAt: DateType;
}

export const FETCH_CURRENCY_RATES_QUERY = gql`
  query CurrencyRates(
    $filters: CurrencyRatesFilters
    $sort: [CurrencyRatesSortEnum!]
    $offset: Int
    $limit: Int
    $source: String
    $trackTotalHits: Boolean
  ) {
    currencyRates(
      filters: $filters
      sort: $sort
      limit: $limit
      offset: $offset
      source: $source
      trackTotalHits: $trackTotalHits
    ) {
      nodes {
        uuid
        id
        baseCurrency
        createdAt
        data
      }
      paginationInfo {
        currentPage
        firstPage
        lastPage
        limitValue
        nextPage
        outOfRange
        prevPage
        totalCount
        totalPages
      }
      sql
    }
  }
`;
